import { useContext } from "react";
import { InitDataContext } from "../../context/InitDataContext";
import { puedeVerReportes } from "../../components/reportes/accesoReportes.ts";
import DashboardOrdenesCompra from "./dashboard.tsx";
import IndexOrdenCompraLegacy from "./index_legacy.tsx";

// Users with cost centers in centros_costo_vista get the new reports
// dashboard (cost center 29: everything; otherwise scoped to their cost
// centers by useFiltrosReporte). Users with none keep the legacy screen
export default function IndexOrdenesCompra() {
  const { initData } = useContext(InitDataContext);
  return puedeVerReportes(initData) ? (
    <DashboardOrdenesCompra />
  ) : (
    <IndexOrdenCompraLegacy />
  );
}
